module.exports = __webpack_public_path__ + "img/cause_risk.7c8e4d36.png";